import React from 'react'
import { useFormikContext } from 'formik'
import { Select, MenuItem, Typography, Stack } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import type { Dayjs } from 'dayjs'
import type { SelectChangeEvent } from '@mui/material'
import type { FormState } from '../types'
import { presetRange } from '../helpers'
import { SectionTitle } from './SectionTitle'
import { DotLabel } from './DotLabel'
import { PERIODS, CUSTOM } from '../constants'

export const PeriodFilter: React.FC = () => {
  const { values, setFieldValue, setValues } = useFormikContext<FormState>()

  const handlePeriodChange = (e: SelectChangeEvent<string>) => {
    const period = e.target.value
    if (period === CUSTOM) return
    setValues({ ...values, period, dateRange: presetRange(period) })
  }

  const handleDateChange = (index: 0 | 1) => (value: Dayjs | null) =>
    setValues({
      ...values,
      period: CUSTOM,
      dateRange:
        index === 0
          ? [value, values.dateRange[1]]
          : [values.dateRange[0], value],
    })

  return (
    <>
      <SectionTitle>Período</SectionTitle>
      <Select
        value={values.period}
        onChange={handlePeriodChange}
        size="small"
        fullWidth
        displayEmpty
        sx={{ mb: 1.5 }}
        renderValue={(value) => (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {PERIODS.find((p) => p.value === value)?.label}
          </Typography>
        )}
      >
        {PERIODS.filter((p) => p.value !== CUSTOM || values.period === CUSTOM).map(
          (p) => (
            <MenuItem key={p.value} value={p.value}>
              <DotLabel label={p.label} active={values.period === p.value} />
            </MenuItem>
          ),
        )}
      </Select>

      <SectionTitle>Período personalizado</SectionTitle>
      <Stack direction="row" spacing={2} sx={{ mb: 1.5 }}>
        <DatePicker
          label="Início"
          value={values.dateRange[0]}
          onChange={handleDateChange(0)}
          slotProps={{ textField: { size: 'small', sx: { flex: 1 } } }}
        />
        <DatePicker
          label="Fim"
          value={values.dateRange[1]}
          onChange={handleDateChange(1)}
          slotProps={{ textField: { size: 'small', sx: { flex: 1 } } }}
        />
      </Stack>
    </>
  )
}
